import ApiBase from "./base";
import { jsonToQueryString } from "../shared/utils";

export const _ORDER_URL = "order";

export async function getOrderList(params) {
  const response = await ApiBase.get(
    `${_ORDER_URL}?${jsonToQueryString(params)}`
  );

  if (response.success) {
    response.items = response.items.map((e) => ({
      ...e,
      userCountryCode: e?.userDetails?.countryCode,
      userPhoneNumber: e?.userDetails?.phoneNumber,
      userFullName: e?.userDetails?.fullName,
      userFirstName: e?.userDetails?.firstName,
      userLastName: e?.userDetails?.lastName,
      userEmail: e?.userDetails?.email,
      driverCountryCode: e?.driverDetails?.countryCode,
      driverPhoneNumber: e?.driverDetails?.phoneNumber,
      driverFullName: e?.driverDetails?.fullName,
      driverFirstName: e?.driverDetails?.firstName,
      driverLastName: e?.driverDetails?.lastName,
      driverEmail: e?.driverDetails?.email,
    }));
  }

  return response;
}

export async function getOrderDetail(id) {
  const response = await ApiBase.get(
    `${_ORDER_URL}/${id}`
  );

  return response;
}

